import { useEffect } from 'react';
import { TimelineMax, TweenMax } from 'gsap';

import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';
import EfImg from 'elem/ui/ef-img';
import { useAnimate } from '../../utils';
import EFPicture from '@elem/ui/ef-picture';

const { EFPic } = createEFPic('/img/landingPage/');

export default function G(): JSX.Element {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('landingPage');

    const powerInfoList = [
        {
            name: t('secG_Light'),
            type1: t('secG_Light_1'),
            type0: t('secG_Light_0'),
            type2: t('secG_Light_2'),
            type3: t('secG_Light_3'),
        },
        {
            name: t('secG_Phone'),
            type1: t('secG_Phone_1'),
            type0: t('secG_Phone_0'),
            type2: t('secG_Phone_2'),
            type3: t('secG_Phone_3'),
        },
        {
            name: t('secG_WIFI'),
            type1: t('secG_WIFI_1'),
            type0: t('secG_WIFI_0'),
            type2: t('secG_WIFI_2'),
            type3: t('secG_WIFI_3'),
        },
        {
            name: t('secG_CPAP'),
            type1: t('secG_CPAP_1'),
            type0: t('secG_CPAP_0'),
            type2: t('secG_CPAP_2'),
            type3: t('secG_CPAP_3'),
        },
        {
            name: t('secG_TV'),
            type1: t('secG_TV_1'),
            type0: t('secG_TV_0'),
            type2: t('secG_TV_2'),
            type3: t('secG_TV_3'),
        },
        {
            name: t('secG_Refrigerator'),
            type1: t('secG_Refrigerator_1'),
            type0: t('secG_Refrigerator_0'),
            type2: t('secG_Refrigerator_2'),
            type3: t('secG_Refrigerator_3'),
        },
        {
            name: t('secG_AirConditioner'),
            type1: t('secG_AirConditioner_1'),
            type0: t('secG_AirConditioner_0'),
            type2: t('secG_AirConditioner_2'),
            type3: t('secG_AirConditioner_3'),
        },
    ];

    useEffect(() => {
        const { createScene, destroy, layoutH } = useAnimate();

        createScene({
            triggerElement: '.pageG_powerBox',
            triggerHook: 1,
            offset: 200,
            duration: (layoutH * 2) / 3,
        })
            .setTween(
                new TimelineMax().add(
                    TweenMax.to('.pageG_powerBox', 1, {
                        opacity: 1,
                    }),
                ),
            )
            .addTo(aniController);

        return () => destroy();
    }, []);

    return (
        <div className={`landing_page_G1 ${css.landing_page_G1}`}>
            <div className="pageG_powerBox">
                <div className="pageG_powerTitle">{t('secF_powerList')}</div>
                <div className="wrapper">
                    <div className="pageG_powerList">
                        <div className="pageG_powerRow pageG_powerRow_th">
                            <div className="powerRowItem"></div>
                            <div className="powerRowItem">
                                <div>
                                    <EFPicture className="powerItemImg" src="https://websiteoss.ecoflow.com/upload/image/1748225852023/3.png" />

                                    <div className="powerItemTitle">{t('secG_item1_title1')}</div>
                                </div>
                            </div>
                            {locale === 'ca' && (
                                <div className="powerRowItem">
                                    <div>
                                        <EfImg pc="https://websiteoss.ecoflow.com/upload/image/1748226057123/img.png" className="powerItemImg" />
                                        <div className="powerItemTitle">{t('secG_item2_title1')}</div>
                                    </div>
                                </div>
                            )}
                            <div className="powerRowItem">
                                <div>
                                    <EFPicture className="powerItemImg" src="https://websiteoss.ecoflow.com/upload/image/1748225852527/2.png" />
                                    <div className="powerItemTitle">{t('secG_item3_title1')}</div>
                                </div>
                            </div>
                            <div className="powerRowItem">
                                <div>
                                    <EFPicture className="powerItemImg" src="https://websiteoss.ecoflow.com/upload/image/1748225852247/1.png" />

                                    <div className="powerItemTitle">{t('secG_item4_title1')}</div>
                                </div>
                            </div>
                        </div>
                        {(locale === 'au' ? powerInfoList?.slice(0, 5) : powerInfoList).map((item: any, index: number) => (
                            <div className="pageG_powerRow_tr" key={index}>
                                <div className="powerRowItem">
                                    <span className="powerRowItemName">{item.name}</span>
                                </div>
                                <div className="powerRowItem">{item.type1}</div>
                                {locale === 'ca' && <div className="powerRowItem">{item.type0}</div>}
                                <div className="powerRowItem">{item.type2}</div>
                                <div className="powerRowItem">{item.type3}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
